import { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './home-media-section.module.css';
import useMedia from '../../hooks/use-media';
import MediumMediaCard from '../media/medium-media-card';
import MediumReelCard from '../media/medium-reel-card';
import LoadingSpinner from '../common/loading-spinner';
import VideoModal from '../common/video-modal';
import MediaIcon from './home-media-section/media-icon';
import { MediaItem } from '../../types';

export default function HomeMediaSection() {
  const { items: highlightedMedia, loading, error } = useMedia({ highlightsOnly: true });
  const [selectedMedia, setSelectedMedia] = useState<MediaItem | null>(null);
  const displayItems = highlightedMedia.slice(0, 4);

  const handlePlay = (item: MediaItem) => {
    setSelectedMedia(item);
  };

  const handleMediaCtaClick = () => {
    try {
      window.analytics?.trackEvent('all_media_click', {
        link_text: 'All Media',
        link_url: '/media',
        destination: '/media',
        page_section: 'home_media_section',
        cta_location: 'home_media_section',        
      });
    } catch { }
  };

  return (
    <section id="media" className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className="section-header center">In the Media</h2>
        </div>

        {loading ? (
          <LoadingSpinner />
        ) : (
          <div className={styles.grid}>
            {displayItems.map((item) => (
              <div key={item.id} className={styles.cardWrapper}>
                {item.layout === 'reel' ? (
                  <MediumReelCard item={item} onPlay={handlePlay} />
                ) : (
                  <MediumMediaCard item={item} onPlay={handlePlay} />
                )}
              </div>
            ))}

            <Link
              to="/media"
              className={styles.ctaCard}
              onClick={handleMediaCtaClick}
            >
              <MediaIcon className={styles.ctaIcon} />
              <p className={styles.ctaTagline}>More interviews, podcasts & features</p>
              <span className={styles.ctaLink}>
                View all media
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </span>
            </Link>
          </div>
        )}

        {selectedMedia && (
          <VideoModal
            item={selectedMedia}
            onClose={() => setSelectedMedia(null)}
          />
        )}
      </div>
    </section>
  );
}
